import React, { FC } from "react";

import { InlinePart, parseHelpReply } from "./helpChat.utils";

const Inline: FC<{ parts: InlinePart[] }> = ({ parts }) => (
  <>
    {parts.map((part, index) =>
      part.bold ? (
        <strong key={index} className={"font-bold text-[#1F2433]"}>
          {part.text}
        </strong>
      ) : (
        <React.Fragment key={index}>{part.text}</React.Fragment>
      ),
    )}
  </>
);

/**
 * The assistant's answer: paragraphs, numbered steps, bullets and bold
 * labels. Everything is rendered as text (no HTML from the server).
 */
export const HelpReplyText: FC<{ text: string }> = ({ text }) => (
  <div className={"space-y-2"}>
    {parseHelpReply(text).map((block, index) => {
      if (block.type === "ol") {
        return (
          <ol key={index} start={block.start} className={"space-y-1.5"}>
            {block.items.map((item, itemIndex) => (
              <li key={itemIndex} className={"flex gap-2"}>
                <span
                  className={
                    "mt-[1px] inline-flex h-[18px] min-w-[18px] shrink-0 items-center justify-center rounded-full bg-[#EEEAFF] px-1 text-[10.5px] font-extrabold text-[#6B4EFF]"
                  }>
                  {block.start + itemIndex}
                </span>
                <span className={"min-w-0"}>
                  <Inline parts={item} />
                </span>
              </li>
            ))}
          </ol>
        );
      }
      if (block.type === "ul") {
        return (
          <ul key={index} className={"space-y-1 pl-4"}>
            {block.items.map((item, itemIndex) => (
              <li key={itemIndex} className={"list-disc marker:text-[#B4BAC8]"}>
                <Inline parts={item} />
              </li>
            ))}
          </ul>
        );
      }
      return (
        <p key={index}>
          <Inline parts={block.parts} />
        </p>
      );
    })}
  </div>
);
